import { ref } from 'vue'
import { defineStore } from 'pinia'
import api from '@/api/axios'

export const useAuthStore = defineStore('auth', () => {
  // Load tokens from localStorage if available
  const accessToken = ref(localStorage.getItem('accessToken'))
  const refreshToken = ref(localStorage.getItem('refreshToken'))
  const user = ref(JSON.parse(localStorage.getItem('user')) || null)
  const error = ref(null)
  const loading = ref(false)

  // Set token in axios if present
  if (accessToken.value) {
    api.defaults.headers.common['Authorization'] = accessToken.value
  }

  async function login({ email, username, password }) {
    loading.value = true
    error.value = null
    try {
      const res = await api.post('/auth/login', { email, username, password })
      user.value = {
        id: res.data.id,
        username: res.data.username,
        email: res.data.email,
        role: res.data.role,
      }
      accessToken.value = res.data.accessToken
      refreshToken.value = res.data.refreshToken
      // Persist tokens and user
      localStorage.setItem('accessToken', accessToken.value)
      localStorage.setItem('refreshToken', refreshToken.value)
      localStorage.setItem('user', JSON.stringify(user.value))
      return true
    } catch (err) {
      error.value = err.response?.data?.error || 'Login failed'
      return false
    } finally {
      loading.value = false
    }
  }

  function logout() {
    user.value = null
    accessToken.value = null
    refreshToken.value = null
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    delete api.defaults.headers.common['Authorization']
  }

  return { user, accessToken, refreshToken, error, loading, login, logout }
})